import Api from "../api";
import axios from "axios";
import { APIENDPOINT } from "@/app.config";
import { News, NewsDto, NewsInstanceGroup, NewsRenderModel, StatusEnum } from "@/services/news/types";

export async function getAllNews(): Promise<Array<News>> {
    return new Promise((resolve, reject) => {
        Api.get("/news").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getNewsById(id: string): Promise<NewsDto> {
    return new Promise((resolve, reject) => {
        Api.get(`/news/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function createNews(model: FormData): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/news", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function updateNews(model: FormData): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/news", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function deleteNews(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/news/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getNewsInstanceGroups(id: string): Promise<Array<NewsInstanceGroup>> {
    return new Promise((resolve, reject) => {
        Api.get(`/news/instancegroups/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function setStatus(id: string, status: StatusEnum): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/news/setstatus", { id: id, status: status }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function renderInstanceNews(id: string, date: Date, language: string, apiKey: string): Promise<NewsRenderModel[]> {
    return new Promise((resolve, reject) => {
        const configuration = { headers: { NewsRenderApiKey: apiKey } };
        axios.post(APIENDPOINT + `/news/render/instance`, { instanceId: id, date: date, language: language }, configuration).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function renderNews(id: string, language: string): Promise<NewsRenderModel> {
    return new Promise((resolve, reject) => {
        Api.post(`/news/render/news`, { newsId: id, language: language }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};
